import { render, staticRenderFns } from "./LexologyForm.vue?vue&type=template&id=6a958460&"
import script from "./LexologyForm.vue?vue&type=script&lang=js&"
export * from "./LexologyForm.vue?vue&type=script&lang=js&"
import style0 from "./LexologyForm.vue?vue&type=style&index=0&id=6a958460&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports